import { CreateMemberPasswordResetCodeErrorCodeV1, CreateMemberPasswordResetCodeErrorV1 } from '@vista-digital/ocapi-client';
import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { configurationSettings } from '../../../../../configuration/configuration-settings';
import { LoyaltyMemberIdentifier } from '../../../../../configuration/types/loyalty/loyalty-member-identifier';
import { CommonErrorCodes } from '../../../../../types/errors/common-error-codes';
import { logger } from '../../../../../utils/logger';
import { nonEmptyStringValidator } from '../../../../../utils/validators/string';
import { LoyaltyDomainError, LoyaltyDomainSpecificErrorCode } from '../../../types/error';
export const createMemberPasswordResetCode = async (request, captchaResponse) => {
    const memberIdentifier = configurationSettings.data.loyalty.authentication.memberIdentifier === LoyaltyMemberIdentifier.Email
        ? request.email
        : request.username;
    if (!memberIdentifier ||
        !nonEmptyStringValidator(memberIdentifier, logger.error, 'createMemberPasswordResetCode')) {
        throw new Error('Cannot create password reset code without a loyalty member identifier');
    }
    try {
        await ocapiClient.instance.v1.loyalty.members.passwordReset.createCode(request, captchaResponse);
    }
    catch (error) {
        throw handleCreatePasswordResetError(error);
    }
};
const handleCreatePasswordResetError = (error) => {
    if (!(error instanceof CreateMemberPasswordResetCodeErrorV1))
        throw error; // Unexpected error, rethrow immediately
    const errorCode = convertApiToDomainErrorCode(error.errorCode);
    return new LoyaltyDomainError(errorCode, error.message);
};
const convertApiToDomainErrorCode = (errorCode) => {
    switch (errorCode) {
        case CreateMemberPasswordResetCodeErrorCodeV1.EmailOrUsernameNotProvided:
            return LoyaltyDomainSpecificErrorCode.NoEmailOrUsername;
        default:
            return CommonErrorCodes.UnknownError;
    }
};
